export const DRAWER_FLOWS = {
  DEFAULT: 'default',
  FIT_OPTIONS: 'fitOptions'
};

const FLOW_CONTENT = {
  [DRAWER_FLOWS.FIT_OPTIONS]: {
    drawerHeading: 'Options That Fit',
    currentItemHeading: 'Current Item',
    differentItemHeading: 'Similar Items That Fit Your Space',
    emptyStateMessage: 'We\'re sorry, there are no similar items that fit your space.',
    showDoesNotFitBadge: true
  }
};

export const getFlowContent = (flow) => FLOW_CONTENT[flow] || {};
